import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { appStateFeature } from 'app/state/app-state/app-state.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(appStateFeature)],
})
export class AppStateModule {}
